import { Component, OnDestroy, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApplicationCreationValidators } from 'app/validators/app-create/app-creation-validators';
import { Toast } from 'app/shared/components/toast/toast.service';
import { Subscription } from 'rxjs/Subscription';
import { Application } from 'app/shared/services/app/application/application.model';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';
import { Session } from 'app/shared/services/session/session.service';
import { ImageService } from 'app/shared/services/image/image.service';
import { ImageLibraryCropperModalComponent } from 'app/shared/components/image-library-cropper-modal/image-library-cropper-modal.component';

@Component({
  selector: 'tog-app-general-form',
  templateUrl: './app-general-form.component.html',
  styleUrls: ['./app-general-form.component.scss'],
  providers: [ImageService]
})
export class AppGeneralFormComponent implements OnInit, OnDestroy {
  generalSettingsForm: FormGroup;
  formChangeSubscription: Subscription;
  isValid: boolean;
  editMode: boolean = false;

  @Input() appToEdit: Application;

  constructor(private _fb: FormBuilder,
              private _toast: Toast,
              private _ab: AppBuilderService,
              private _session: Session,
              public imageService: ImageService) {
    this.generalSettingsForm = _fb.group({
      app_name: ['', Validators.required],
      descr: ['', Validators.required],
      version: ['', [Validators.required, ApplicationCreationValidators.mustBeVersion]],
      package: ['', [Validators.required, ApplicationCreationValidators.mustBePackage,
                                          ApplicationCreationValidators.pkgNameMustBeUnique]],
      sys_name: ['', [Validators.required,
                      ApplicationCreationValidators.cannotContainSpace,
                      ApplicationCreationValidators.cannotContainSpecial,
                      ApplicationCreationValidators.sysNameMustBeUnique]]
    });
  }

  ngOnInit() {
    this.formChangeSubscription = this.generalSettingsForm.valueChanges.subscribe((formValue) => {
      this._ab.updateForm(this.generalSettingsForm, 'general');
    });
    this._session.user()
    .then((user) => {
      ApplicationCreationValidators.apps = user.applications;
    });
  }

  setUpAppToEdit() {
    if (this.appToEdit) {
      this.editMode = true;

      this.generalSettingsForm.controls['app_name'].setValue(this.appToEdit.full_name);
      this.generalSettingsForm.controls['descr'].setValue(this.appToEdit.settings.descr);
      this.generalSettingsForm.controls['version'].setValue(this.appToEdit.settings.version);
      this.generalSettingsForm.controls['package'].setValue(this.appToEdit.settings.package);
      this.generalSettingsForm.controls['sys_name'].setValue(this.appToEdit.sys_name);
      this.generalSettingsForm.controls['sys_name'].disable();
      this.generalSettingsForm.controls['package'].disable();
      this.generalSettingsForm.markAsPristine();
    }
  }

  maxFileSizeExceeded() {
    this._toast.error('Image is too large. Please select an image less than 1MB.');
  }

  ngOnDestroy() {
    if (this.formChangeSubscription) this.formChangeSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/forms/components/app-general-form/app-general-form.component.ts